const Gpay = () => {
  return (
    <svg
      width="30"
      height="16"
      viewBox="0 0 97 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1075_991)">
        <path
          d="M71.2341 0H26.298C12.2554 0 0.766052 11.475 0.766052 25.5C0.766052 39.525 12.2554 51 26.298 51H71.2341C85.2767 51 96.7661 39.525 96.7661 25.5C96.7661 11.475 85.2767 0 71.2341 0Z"
          fill="white"
        />
        <path
          d="M71.2341 2.0655C74.3873 2.0655 77.4512 2.69025 80.3363 3.91425C83.132 5.1 85.6341 6.79575 87.8044 8.9505C89.9618 11.1052 91.6597 13.617 92.8469 16.4093C94.0724 19.2908 94.698 22.3507 94.698 25.5C94.698 28.6493 94.0724 31.7092 92.8469 34.5907C91.6597 37.383 89.9618 39.882 87.8044 42.0495C85.6469 44.2042 83.132 45.9 80.3363 47.0857C77.4512 48.3097 74.3873 48.9345 71.2341 48.9345H26.298C23.1448 48.9345 20.0809 48.3097 17.1958 47.0857C14.4001 45.9 11.898 44.2042 9.72775 42.0495C7.57031 39.8947 5.87243 37.383 4.6852 34.5907C3.45967 31.7092 2.83414 28.6493 2.83414 25.5C2.83414 22.3507 3.45967 19.2908 4.6852 16.4093C5.87243 13.617 7.57031 11.118 9.72775 8.9505C11.8852 6.79575 14.4001 5.1 17.1958 3.91425C20.0809 2.69025 23.1448 2.0655 26.298 2.0655H71.2341ZM71.2341 0H26.298C12.2554 0 0.766052 11.475 0.766052 25.5C0.766052 39.525 12.2554 51 26.298 51H71.2341C85.2767 51 96.7661 39.525 96.7661 25.5C96.7661 11.475 85.2767 0 71.2341 0Z"
          fill="#3C4043"
        />
        <path
          d="M46.6477 27.3105V35.0242H44.1967V15.9757H50.6945C52.3413 15.9757 53.7456 16.524 54.8945 17.6205C56.069 18.717 56.6562 20.0557 56.6562 21.6367C56.6562 23.256 56.069 24.5947 54.8945 25.6785C53.7584 26.7622 52.3541 27.2977 50.6945 27.2977H46.6477V27.3105ZM46.6477 18.3217V24.9645H50.7456C51.7158 24.9645 52.5328 24.633 53.1711 23.9827C53.8222 23.3325 54.1541 22.542 54.1541 21.6495C54.1541 20.7697 53.8222 19.992 53.1711 19.3417C52.5328 18.666 51.7286 18.3345 50.7456 18.3345H46.6477V18.3217Z"
          fill="#3C4043"
        />
        <path
          d="M63.0648 21.5603C64.8776 21.5603 66.3073 22.0448 67.3541 23.0138C68.401 23.9828 68.9244 25.3088 68.9244 26.9918V35.0243H66.5882V33.2138H66.4861C65.4776 34.7056 64.1244 35.4451 62.4392 35.4451C60.9967 35.4451 59.7967 35.0243 58.8265 34.1701C57.8563 33.3158 57.3712 32.2576 57.3712 30.9826C57.3712 29.6311 57.8818 28.5601 58.9031 27.7696C59.9243 26.9663 61.2903 26.5711 62.9882 26.5711C64.4435 26.5711 65.6435 26.8388 66.5754 27.3743V26.8133C66.5754 25.9591 66.2435 25.2451 65.5669 24.6458C64.8903 24.0466 64.0988 23.7533 63.1924 23.7533C61.8265 23.7533 60.7414 24.3271 59.9499 25.4873L57.7924 24.1358C58.9797 22.4146 60.7414 21.5603 63.0648 21.5603ZM59.8988 31.0208C59.8988 31.6583 60.1669 32.1938 60.7158 32.6146C61.252 33.0353 61.8903 33.2521 62.618 33.2521C63.652 33.2521 64.5712 32.8696 65.3754 32.1046C66.1797 31.3396 66.5882 30.4471 66.5882 29.4143C65.8222 28.8151 64.7627 28.5091 63.3967 28.5091C62.401 28.5091 61.5712 28.7513 60.9073 29.2231C60.2307 29.7203 59.8988 30.3196 59.8988 31.0208Z"
          fill="#3C4043"
        />
        <path
          d="M82.2519 21.981L74.0817 40.749H71.5541L74.5924 34.1827L69.2051 21.981H71.8732L75.7541 31.3395H75.8051L79.5839 21.981H82.2519Z"
          fill="#3C4043"
        />
        <path
          d="M36.8983 25.755C36.8983 24.9569 36.8269 24.1931 36.6941 23.4587H26.42V27.6662L32.3371 27.6675C32.0971 29.0675 31.3247 30.2609 30.1413 31.0565V33.7862H33.6634C35.72 31.8852 36.8983 29.0751 36.8983 25.755Z"
          fill="#4285F4"
        />
        <path
          d="M30.1427 31.0565C29.1622 31.7169 27.8997 32.1033 26.4227 32.1033C23.5695 32.1033 21.149 30.1831 20.2822 27.5948H16.649V30.4101C18.449 33.9775 22.1486 36.4255 26.4227 36.4255C29.3767 36.4255 31.8584 35.4552 33.6648 33.785L30.1427 31.0565Z"
          fill="#34A853"
        />
        <path
          d="M19.9401 25.5064C19.9401 24.7796 20.0613 24.0771 20.2822 23.4166V20.6014H16.649C15.9047 22.0766 15.486 23.7418 15.486 25.5064C15.486 27.271 15.906 28.9361 16.649 30.4113L20.2822 27.5961C20.0613 26.9356 19.9401 26.2331 19.9401 25.5064Z"
          fill="#FABB05"
        />
        <path
          d="M26.4227 18.9083C28.035 18.9083 29.4788 19.4629 30.6188 20.5467L33.7401 17.4319C31.8444 15.6685 29.3729 14.5861 26.4227 14.5861C22.1499 14.5861 18.449 17.0341 16.649 20.6015L20.2822 23.4167C21.149 20.8285 23.5695 18.9083 26.4227 18.9083Z"
          fill="#E94235"
        />
      </g>
      <defs>
        <clipPath id="clip0_1075_991">
          <rect
            width="96"
            height="51"
            fill="white"
            transform="translate(0.766052)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Gpay;
